import HttpFactory from "~/repository/http.factory";
import type { PaginatedResponse } from "~/types/shared/response/paginated.response";
import type { PaginationRequest } from "~/types/shared/request/pagination.request";
import type { SelectInput } from "~/types/shared/select.input";
import type { DeployListResponse } from "~/types/deploy/response/deploy.list.response";
import type { ResultCollectionResponse } from "~/types/shared/response/result.collection.response";
import type { ResultResponse } from "~/types/shared/response/result.response";
import type { DeployDetailsResponse } from "~/types/deploy/response/deploy.details.response";

export default class DeployClient extends HttpFactory {
  private ADMIN_RESOURCE = "/admin/transmission";
  private CHOICES_RESOURCE = "/choices/transmission";
  private headers: HeadersInit = {
    "Content-type": "application/json",
  };

  async findAll(
    request?: PaginationRequest
  ): Promise<PaginatedResponse<DeployListResponse>> {
    return await this.call<PaginatedResponse<DeployListResponse>>(
      "POST",
      `${this.ADMIN_RESOURCE}/list`,
      this.getAuthenticationHeaders(),
      request
    );
  }

  async getStatuses(): Promise<SelectInput[]> {
    return await this.call<SelectInput[]>(
      "GET",
      `${this.CHOICES_RESOURCE}/statuses`,
      this.getAuthenticationHeaders()
    );
  }

  async getTypes(): Promise<SelectInput[]> {
    return await this.call<SelectInput[]>(
      "GET",
      `${this.CHOICES_RESOURCE}/types`,
      this.getAuthenticationHeaders()
    );
  }

  async runOne(uuid: string): Promise<ResultResponse> {
    return await this.call<ResultResponse>(
      "POST",
      `${this.ADMIN_RESOURCE}/run/deploy/${uuid}`,
      this.getAuthenticationHeaders()
    );
  }

  async runAllByScodi(uuid: string): Promise<ResultCollectionResponse> {
    return await this.call<ResultCollectionResponse>(
      "POST",
      `${this.ADMIN_RESOURCE}/run/scodi/${uuid}`,
      this.getAuthenticationHeaders()
    );
  }

  async runAllByCampaign(uuid: string): Promise<ResultCollectionResponse> {
    return await this.call<ResultCollectionResponse>(
      "POST",
      `${this.ADMIN_RESOURCE}/run/campaign/${uuid}`,
      this.getAuthenticationHeaders()
    );
  }

  async runAll(): Promise<ResultCollectionResponse> {
    return await this.call<ResultCollectionResponse>(
      "POST",
      `${this.ADMIN_RESOURCE}/run/all`,
      this.getAuthenticationHeaders()
    );
  }

  async getDetails(uuid: string): Promise<DeployDetailsResponse> {
    return await this.call<DeployDetailsResponse>(
      "GET",
      `${this.ADMIN_RESOURCE}/${uuid}`,
      this.getAuthenticationHeaders()
    );
  }
}
